<div class="d-flex align-items-center" [ngClass]="{'mr-30' : isLoggedin && !isSmallScreen && isCustom}">
  @if(!isCustom || (isSmallScreen || isLoggedin  )){
    <div class="menu-icon-btn" (click)="onToggleMenu(true)">  
      @if(isCustom){
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none">
          <path d="M8.48009 9.74924C10.9652 9.74924 12.9797 7.73469 12.9797 5.24962C12.9797 2.76455 10.9652 0.75 8.48009 0.75C5.99502 0.75 3.98047 2.76455 3.98047 5.24962C3.98047 7.73469 5.99502 9.74924 8.48009 9.74924Z" [attr.stroke]="customConfig.menu.iconColors" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16.2107 18.7526C16.2107 15.2699 12.746 12.4531 8.48034 12.4531C4.2147 12.4531 0.75 15.2699 0.75 18.7526" [attr.stroke]="customConfig.menu.iconColors" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      }@else{
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 8L19 8" [attr.stroke]="defaultBurgerColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M1 0.800781L19 0.800783" [attr.stroke]="defaultBurgerColor" stroke-width="1.5" stroke-linecap="round"/>
          <path d="M1 15.2012L19 15.2012" [attr.stroke]="defaultBurgerColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      }
    </div>
  }

  @if(isCustom){
      <div style="width: 45px;height: 43px;"></div>
    <div class="langPosition" [ngClass]="{'dropDownStyle' : !isDropDownClosed,'r-11': isLoggedin && !isSmallScreen && isCustom,'ml-30' : isLoggedin, 'lang-position-brixen': isCustom && customConfig?.domain === 'brixen'}">
      <img class="imglang" (click)="toggleDropdown()" [ngClass]="{'hidden' : !isDropDownClosed}" [src]="'assets/images/langpng/' + languageNameSelected + '.png'" style="margin-top: 3px;">
      <li *ngFor="let language of displayLanguages" [ngClass]="{'hidden' : isDropDownClosed}" id="languageDropdown" class="mb-10">
        <a [routerLink]="[]" (click)="changeLanguage(language)"
        [ngClass]="{'active-item' : language.code == languageSelected}"><img class="imglang" [src]="'assets/images/langpng/' + language.code + '.png'"></a>
      </li>					
    </div>
  }
</div>
<div class="blur-bg" [class.show]="isMenuOpen" (click)="onToggleMenu(false)"></div>
<div class="menu-container" [class.open]="isMenuOpen" [appPreventParentScroll]="isMenuOpen">
  <div class="d-flex align-items-center mb-20">
    @if (isLoggedin) {
      @if (isHeaderBreakpoint) {
        <div class="d-flex align-items-center bearer-user mr-auto">
          <span class="material-symbols-outlined client-user">person</span>
          <div class="flex-column ml-5 user-name">
            <span class="inverted">{{'general.hello' | translate}},</span><span>{{ bearerUser }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center">
          @if (isUserPR && !isCustom) {
            <div class="pr-button mr-15" [class.pr-button-active]="activeMenuIndex === 1"  (click)="setActiveMenu(1)">PR</div>
          }
          <div class="material-symbols-outlined menu-button" [class.menu-button-active]="activeMenuIndex === 0" (click)="setActiveMenu(0)">
            menu
          </div>
        </div>
      } @else {
        <div class="d-flex align-items-center mr-auto">
          <span class="desktop-menu-title" [class.desktop-menu-title-active]="activeMenuIndex === 0" (click)="setActiveMenu(0)">Menu</span>
          @if (isUserPR && !isCustom) {
            <div class="desktop-pr-button ml-15" [class.desktop-pr-button-active]="activeMenuIndex === 1" (click)="setActiveMenu(1)">
              PR
            </div>
          }
        </div>
      }
    } @else {
      <span class="fz-18 fw-400 mr-auto" style="line-height: 20px;">Menu</span>
    }
    <span class="material-symbols-outlined close-icon-button ml-15" (click)="onToggleMenu(false)">cancel</span>
  </div>
  <div style="flex: 1 1 100%;" class="flex-column">
    @if (isLoggedin){
      @if (activeMenuIndex === 1 && isUserPR && !isCustom) {
        <div class="py-10 border-1px-bottom">
          <span class="menu-item" (click)="onToggleMenu(false)" routerLink="/promoter/dashboard">{{ 'general.dashboard' | translate }}</span>
        </div>
        <div class="py-10 border-1px-bottom">
          <span class="menu-item" (click)="onToggleMenu(false)" routerLink="/promoter/il-mio-staff">{{ 'general.staff' | translate }}</span>
        </div>
        <div class="py-10 border-1px-bottom">
          <span class="menu-item" (click)="onToggleMenu(false)" routerLink="/promoter/eventi">{{ 'general.pReventS' | translate }}</span>
        </div>
        <div class="py-10 border-1px-bottom">
          <span class="menu-item" (click)="onProdotiInVendita()">{{ 'general.pRVetrina' | translate }}</span>
        </div>
        <div class="py-10 border-1px-bottom">
          <span class="menu-item" (click)="onToggleMenu(false)" routerLink="/promoter/inviti-ricevuti">{{ 'general.invites' | translate }}</span>
        </div>
      } @else {
        @for (menuItem of filteredMenuItems; track menuItem) {
          <div class="py-10 border-1px-bottom">
            <span [routerLink]="menuItem.link" class="menu-item" (click)="onToggleMenu(false)">
              {{ menuItem.translationKey | translate }}
            </span>
          </div>
        }
        @if(!isCustom){
          <ng-container *ngTemplateOutlet="language"></ng-container>
        }
        
      }
      <div class="mt-auto pt-10">
        <span class="menu-item" (click)="onLogoutClick()">{{ 'general.logout' | translate }}</span>
      </div>
    } @else {
      <div class="py-10 border-1px-bottom">
        <span class="menu-item text-capitalize" (click)="onLoginClick()">{{ 'login' | translate }}</span>
      </div>
      <div class="py-10 border-1px-bottom">
        <span class="menu-item text-capitalize" (click)="onToggleMenu(false)" routerLink="/registrati">{{ 'register' | translate }}</span>
      </div>
      @if(!isCustom){
        <div class="py-10 border-1px-bottom">
          <span class="menu-item text-capitalize"> <a href="https://www.ciaotickets.com/it/punti-vendita" target="_blank"> {{ 'puntivendita' | translate }} </a></span>
        </div>
        <div class="py-10 border-1px-bottom">
          <span class="menu-item text-capitalize"> <a href="https://www.ciaotickets.com/it/faq-page" target="_blank"> {{ 'domandefrequenti' | translate }} </a></span>
      </div>
      }
      @if(!isCustom){
        <ng-container *ngTemplateOutlet="language"></ng-container>
      }
    }
  </div>
</div>

<ng-template #language>
  <div class="py-5">
    @for (language of displayLanguages; track language; let i = $index) {
      @if (!isDropDownClosed || i === 0) {
        <div id="languageDropdown" class="py-5 border-1px-bottom" [ngClass]="{'pl-40' : i != 0}">
          <span class="align-items-center d-flex py-5 cursor-pointer color-blue-lang"
            (click)="i === 0 ? toggleDropdownLang(true) : changeLanguage(language)"
            [ngClass]="{'active-item' : language.code == languageSelected}">
            <img class="langFlag mr-10" [src]="'assets/images/langpng/' + language.code + '.png'">
            {{ language.name }}
            @if (i === 0) {
              <span
                class="material-symbols-outlined ml-5 dropdown-icon color-blue-lang"
                [class.rotated]="!isDropDownClosed">
                keyboard_arrow_down
              </span>
            }
          </span>
        </div>
      }
    }
  </div>
</ng-template>